import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css';
import { bindActionCreators } from 'redux';
import { CancelButton } from '_components';
import { DBDropDownObjective, DBTextFieldObjective, ObjectiveFlag, ToolTipBulb } from '_components';
import { noteActions } from '_actions';
class PatientCareCenterNoteObjectiveNeuroToneDetails extends React.Component {

  remove() {
    this.props.removeChildRow(this.props.noteId, 'PTOBJECTIVEPEDSTONE', 'OT', this.props.id);
}
    renderToolTip() {
        return( 
        <ToolTipBulb uid={this.props.id} position='right' width={400} size='extra-small'>
        <b>Modified Ashworth Scale</b>
        <br />
        
        <div className={styles.toolTip_row}>
          <span>0 — No increase in muscle tone</span>
        </div>
        <br />
        <div className={styles.toolTip_row}>
          <span>1 — Slight increase in muscle tone, manifested by a catch and relase or by minimal resistance at the end of the range of motion when the affected part(s) is moved in flexion or extension</span>
        </div>
        <br />
        <div className={styles.toolTip_row}>
          <span>1+ - Slight increase in muscle tone, manifested by a catch and release or by minimal resistance throughout the remainder (less than half) of the range of motion</span>
        </div>
        <br />
        <div className={styles.toolTip_row}>
          <span>2 — More marked increase in muscle tone through most of the range of motion, but affected part(s) easily flexed</span>
        </div>
        <br />
        <div className={styles.toolTip_row}>
          <span>3 — Considerable increase in tone, passive movement difficult</span>
        </div>
        <br />
        <div className={styles.toolTip_row}>
          <span>4 — Affected part(s) rigid in flexion or extension</span>
        </div>
  
        </ToolTipBulb>
    )
      }

    render() {
        return (
            <div>
                <div className={styles.textfield_row}>
                  <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                    </div>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText={`Tone ${this.props.id.toString()}`} />
                    <span className={styles.add_button} />
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDSTONE'
                        entityKeyColumn='OTNO'
                        entityKeyValue={this.props.id}
                        field='OTMUSCLEGROUP'
                        className={styles.column}
                    />
                   
                    <DBDropDownObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDSTONE'
                        entityKeyColumn='OTNO'
                        entityKeyValue={this.props.id}
                        field='OTSCORE'
                        className={styles.arom_hand}
                        masterEntity='PTMASTERTONESCORES'
                        masterEntityKeyColumn='MTSNO'
                        masterEntitySort='MTSORDER'
                        masterEntityDisplay='MTSNAME' /> 
                    {this.props.scoreValue && (
                        <>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDSTONE'
                            entityKeyColumn='OTNO'
                            entityKeyValue={this.props.id}
                            field='OTASHWORTH'
                            className={styles.score}
                            masterEntity='PTMASTERASHWORTH'
                            masterEntityKeyColumn='MASNO'
                            masterEntitySort='MASORDER'
                            masterEntityDisplay='MASNAME' />
                            <span className={styles.lightbulb}>
                            {this.renderToolTip()}
                        </span>
                        </>
                    )}
                    
                </div>
            </div>
        )
     
    }

}

function mapDispatchToProps(dispatch) {
  return {
      removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
  };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    return {
        noteId: noteId,
        scoreValue: (state.entities.notes.PTOBJECTIVEPEDSTONE[ownprops.id].OTSCORE !== undefined 
            && state.entities.notes.PTOBJECTIVEPEDSTONE[ownprops.id].OTSCORE !== null
            && state.entities.notes.PTOBJECTIVEPEDSTONE[ownprops.id].OTSCORE === 4
        ),
        flagged: (state.entities.notes.PTOBJECTIVEPEDSTONE[ownprops.id].OTSCORE !== undefined 
            && state.entities.notes.PTOBJECTIVEPEDSTONE[ownprops.id].OTSCORE !== null
            && state.entities.notes.PTOBJECTIVEPEDSTONE[ownprops.id].OTSCORE !== 2
        ),
    };
}

const connectedPatientCareCenterNoteObjectiveNeuroToneDetails = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveNeuroToneDetails);
export { connectedPatientCareCenterNoteObjectiveNeuroToneDetails as PatientCareCenterNoteObjectiveNeuroToneDetails };

